import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const fniVerificationRequest = createAction(
  types.FNI_VERIFICATION_REQUEST,
);
export const fniVerificationSuccess = createAction(
  types.FNI_VERIFICATION_SUCCESS,
);
export const fniVerificationFailure = createAction(
  types.FNI_VERIFICATION_FAILURE,
);
export const fniVerificationReset = createAction(types.FNI_VERIFICATION_RESET);

const verificationsActions = {
  fniVerificationRequest,
  fniVerificationSuccess,
  fniVerificationFailure,
  fniVerificationReset,
};

export default verificationsActions;
